module.exports = __webpack_public_path__ + "img/image8.c1da9b20.png";